import {
  operations as appStorageOperations,
  utils as appStorageUtils,
} from '@saucelabs/sl-module-app-storage';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import { actions as groupActions } from '../group';

const uploadSelectedFilesAndRefreshGroups = (files: File[]) => (
  (dispatch: ReduxDispatcher) => ( // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
    Promise.all(files.map(async (file) => {
      try {
        const response = await dispatch(appStorageOperations.uploadFile(file));
        const newFile = response.items[0];

        dispatch(notificationActions.notifySuccess(
          `Successfully uploaded ${newFile.getDisplayName()}`,
          undefined,
          false,
          undefined,
          true,
        ));

        // Refresh the group table after a file upload is finished successfully
        await dispatch(groupActions.fetchGroups());

        return Promise.resolve(response.items[0]);
      } catch (error) {
        let apiError: appStorageUtils.SerializedApiError;

        if (error instanceof Error) {
          apiError = appStorageUtils.handleApiError(error);
        } else {
          apiError = error as appStorageUtils.SerializedApiError;
        }

        const {
          code,
          detail,
          title,
        } = apiError.error;

        dispatch(notificationActions.notifyDanger(
          `Uploading has failed. ${detail}`,
          `${code} ${title}`,
          true,
          undefined,
          true,
        ));
        return Promise.reject(apiError);
      }
    }))));

export default {
  uploadSelectedFilesAndRefreshGroups,
};
